
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import _ from 'lodash';

import Modal from '@/components/modal.vue';
import { assert_not_null, generate_uid } from '@/utils';

// types for function props
type Comparator = (lhs: unknown, rhs: unknown) => boolean;
type Filter = (item: unknown, filter_text: string) => boolean;

@Component({
  components: {
    Modal
  }
})
export default class BatchSelect extends Vue {
  @Prop({ required: true, type: Array })
  choices!: unknown[];

  @Prop({ type: Array })
  value!: unknown[];

  @Prop({ type: Function })
  are_items_equal!: Comparator;

  @Prop({ type: Function })
  filter_fn!: Filter;

  @Prop({required: true, type: String})
  aria_label!: string;

  d_show_batch_select_modal = false;
  d_batch_search_query: string = "";
  d_selected_items: unknown[] = [];

  d_current_focus_index: number | null = null;

  created() {
    this.d_selected_items = this.value.slice();
  }

  async show_batch_select_modal() {
    this.d_show_batch_select_modal = true
    await this.$nextTick();
    (<HTMLElement> this.$refs.listbox_element).focus();
  }

  @Watch("value", { deep: true })
  on_value_change(new_value: unknown[], old_value: unknown[]) {
    this.d_selected_items = this.value.slice();
  }

  focus_enter() {
    if (this.batch_filtered_items.length === 0) {
      return;
    }
    const first_selected_index = this.batch_filtered_items.findIndex((item) => this.item_is_selected(item));
    this.focus_index(first_selected_index === -1 ? 0 : first_selected_index);
  }

  focus_prev() {
    assert_not_null(this.d_current_focus_index);
    this.focus_index(Math.max(0, this.d_current_focus_index - 1));
  }

  focus_next() {
    assert_not_null(this.d_current_focus_index);
    this.focus_index(Math.min(this.batch_filtered_items.length - 1, this.d_current_focus_index + 1));
  }

  focus_index(index: number) {
    this.d_current_focus_index = index;
  }

  toggle_focused_element() {
    if (this.d_current_focus_index !== null) {
      this.batch_toggle_select(this.batch_filtered_items[this.d_current_focus_index]);
    }

  }

  batch_toggle_select(item: unknown) {
    if (_.some(this.d_selected_items, (el) => this.are_items_equal(el, item))) {
      this.d_selected_items = _.filter(
        this.d_selected_items,
        (el) => !this.are_items_equal(el, item)
      );
    }
    else {
      this.d_selected_items.push(item);
    }
  }

  get batch_filtered_items() {
    return _.isEmpty(this.d_batch_search_query) ?
      this.choices :
      _.filter(
        this.choices,
        (item) => this.filter_fn(item, this.d_batch_search_query)
      );
  }

  item_is_selected(item: unknown) {
    return this.d_selected_items.some((el) => this.are_items_equal(el, item))
  }

  get component_uid() {
    return generate_uid();
  }

  option_id(index: number) {
    return `batch-option-${this.component_uid}-${index}`;
  }

  get active_option_id() {
    if (this.d_current_focus_index === null
        || this.d_current_focus_index >= this.batch_filtered_items.length) {
      return undefined;
    }
    return this.option_id(this.d_current_focus_index);
  }

  // Call when user clicks the "confirm" button.
  confirm_selection() {
    this.$emit("input", this.d_selected_items);
    this.d_show_batch_select_modal = false;
  }
}
